export const incomingMessageTypes = {
  gameConfigurationChanged: "gameConfigurationChanged",
  unlink: "unlink",
  linkRequest: "linkRequest",
  codeResponse: "codeResponse",
  selectGameRequest: "selectGameRequest",
  startGame: "startGame",
  abortGame: "abortGame",
  listGamesRequest: "listGamesRequest",
  throw: "throw",
  takeoutStarted: "takeoutStarted",
  takeoutFinished: "takeoutFinished",
  loadGame: "loadGame",
  playerListChanged: "playerListChanged",
  sbcStatusChanged: "sbcStatusChanged",
  sbcRegistrationError: "sbcRegistrationError",
  reconnect: "reconnect",
  linkResponse: "linkResponse"
};

export const outgoingMessageTypes = {
  codeRequest: "codeRequest",
  listGamesResponse: "listGamesResponse",
  gameReady: "gameReady",
  gameOver: "gameOver",
  linkRequestWithToken: "linkRequestWithToken",
  reload: "reload"
};
